import { render, staticRenderFns } from "./chairmans-message.vue?vue&type=template&id=2e289627&"
import script from "./chairmans-message.vue?vue&type=script&lang=js&"
export * from "./chairmans-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports